<template>
    <section class="greentool__container">
        <template v-if="filters && filters.length">
            <div class="greentool__filter">
                <div class="greentool__filterlabel">{{ $t('greentool.filterlabel') }}</div>
                <sal-filter-group :filters="filters"></sal-filter-group>
            </div>
        </template>
        <template v-if="selectedFilters && Object.keys(selectedFilters).length">
            <div class="row">
                <div class="col-12">
                    <sal-filter-selected></sal-filter-selected>
                </div>
            </div>
            <sal-results class="row"></sal-results>
        </template>
    </section>
</template>

<script>
import SalFilterGroup from "@productfinder/components/sal-filter-group/sal-filter-group";
import SalFilterSelected from "@productfinder/components/sal-filter-selected/sal-filter-selected";
import SalResults from "@productfinder/components/sal-results/sal-results";
import {mapGetters,mapState} from 'vuex';

export default {
    name: "greentool",
    components: {SalResults, SalFilterSelected, SalFilterGroup},
    props: {
        searchUrl: ''
    },
    data() {
        return {}
    },
    computed: {
        ...mapState(['total']),
        ...mapGetters(['filters', 'selectedFilters'])
    },
    methods: {
    },
    beforeMount() {
        this.$store.dispatch('setUseHash', false);
        this.$store.dispatch('setConfig', window.GREENTOOL_CONFIG);
        this.$store.dispatch('setLocalization');
        this.$store.dispatch('setApi', {url: window.GREENTOOL_API, baseParamName: 'tx_epim_greentool'} );
        this.$store.dispatch('loadInitialData', window.GREENTOOL_INITIAL);
    }
}
</script>
